import L from "leaflet";
import { Marker } from "react-leaflet";
import { RoadFeatures, RoadFeaturesWithBruksklasse, } from "../../../services/RuteplanAPI";
import { useRouteFeatureDialogStoreActions } from "../../../stores/RouteFeatureDialogStore";

import trafficMessageIconResource from "../../../assets/trafficSituation2.svg"

const trafficMessageIcon = L.icon({
    iconUrl: trafficMessageIconResource,
    iconRetinaUrl: trafficMessageIconResource,
    iconAnchor: [14, 28],
    iconSize: [28, 28]
});

export interface ITrafficMessageMarkersProps {
    
    roadFeatures: RoadFeatures | RoadFeaturesWithBruksklasse;
}

export function TrafficMessageMarkers(props: ITrafficMessageMarkersProps) {

    const { setClickedRoadFeature, setRoadFeatureDialogIsOpen } = useRouteFeatureDialogStoreActions();
    const { roadFeatures } = props;

    return (
        <>
            {roadFeatures.trafficMessages && roadFeatures.trafficMessages.map( (trafficMessage, index: number) => {
                const { location } = trafficMessage;
                return (
                    <Marker 
                        key={trafficMessage.situationId + index}
                        position={[location!.y, location!.x]}
                        icon={trafficMessageIcon}
                        eventHandlers={{
                            click: () => {
                                setClickedRoadFeature(trafficMessage);
                                setRoadFeatureDialogIsOpen(true);
                            }
                        }}
                    />
                )
            })}
            {roadFeatures.swedishTrafficMessages && roadFeatures.swedishTrafficMessages.map( (trafficMessage, index: number) => {
                const { location } = trafficMessage;

                if(location == null) {
                    return(<></>);
                }

                return (
                    <Marker 
                        key={trafficMessage.situationId + index}
                        position={[location!.y, location!.x]}
                        icon={trafficMessageIcon}
                        eventHandlers={{
                            click: () => {
                                setClickedRoadFeature(trafficMessage);
                                setRoadFeatureDialogIsOpen(true);
                            }
                        }}
                    />
                )
            })}
            {roadFeatures.finnishTrafficMessages && roadFeatures.finnishTrafficMessages.map( (trafficMessage, index: number) => {
                const { location } = trafficMessage;
                
                if(location == null) {
                    return(<></>);
                }

                return (
                    <Marker 
                        key={trafficMessage.situationId + index}
                        position={[location!.y, location!.x]}
                        icon={trafficMessageIcon}
                        eventHandlers={{
                            click: () => {
                                setClickedRoadFeature(trafficMessage);
                                setRoadFeatureDialogIsOpen(true);
                            }
                        }}
                    />
                )
            })
            }
        </>
    )
}